import { Gift } from "lucide-react";

const PROMO_URL = "https://www.pressing-sakura.fr/promo-en-cours";

export const PromoOfMonth = () => (
  <a href={PROMO_URL} target="_blank" rel="noopener noreferrer" data-testid="promo-du-mois-btn"
    className="relative inline-flex items-center gap-1.5 whitespace-nowrap bg-gradient-to-r from-pink-500 to-rose-500 text-white font-bold text-xs sm:text-sm px-3 sm:px-4 py-2.5 rounded-full shadow-lg shadow-pink-300/50 hover:scale-105 transition-transform">
    <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-300 rounded-full animate-ping" />
    <span className="absolute -top-1 -right-1 w-3 h-3 bg-yellow-300 rounded-full" />
    <Gift className="w-4 h-4" />Promo du mois
  </a>
);
